import { createAsyncThunk } from '@reduxjs/toolkit';
import reportApi from '~/apis/report';
import {
  GET_ACTIVITY_REPORT,
  GET_CLOSING_RATE_REPORT,
  GET_DASHBOARD,
  GET_FINANCIAL,
  GET_FRANCHISE_MKT_REPORT,
  GET_LEAD_REPORT,
  GET_PROJECT_REPORT,
  GET_REFERRAL_SOURCE_REPORT,
  GET_STAFF_SALE_REPORT,
  GET_TIME_CLOCK_REPORT,
} from '~/utils/constants/actionType';
import {
  IDashboard,
  IFinancial,
  IGetActivity,
  IGetFinancial,
  IResponseGetActivityReport,
  IResponseGetFranchiseMKTReport,
  IResponseGetLeadReport,
  IResponseGetProjectReport,
  IResponseGetSourceReferralReport,
  IResponseGetStaffSaleReport,
  IGetTimeClockReport,
  IResponseGetTimeClockReport,
} from '~/utils/interface/report';

export const handleGetFinancial = createAsyncThunk<IFinancial, IGetFinancial>(
  GET_FINANCIAL,
  async (params: IGetFinancial = {}, { rejectWithValue }) => {
    try {
      const res = await reportApi.getFinancial(params);

      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetDashboard = createAsyncThunk<IDashboard>(GET_DASHBOARD, async (_data, { rejectWithValue }) => {
  try {
    const res = await reportApi.getDashboard();

    return res.data.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
export const handleGetActivityReport = createAsyncThunk<IResponseGetActivityReport, IGetActivity>(
  GET_ACTIVITY_REPORT,
  async (params: IGetActivity = {}, { rejectWithValue }) => {
    try {
      const res = await reportApi.getActivity(params);

      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetFranchiseMKTReport = createAsyncThunk<IResponseGetFranchiseMKTReport, IGetActivity>(
  GET_FRANCHISE_MKT_REPORT,
  async (params: IGetActivity = {}, { rejectWithValue }) => {
    try {
      const res = await reportApi.getFranchiseMKT(params);

      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetLeadReport = createAsyncThunk<IResponseGetLeadReport, IGetActivity>(
  GET_LEAD_REPORT,
  async (params: IGetActivity = {}, { rejectWithValue }) => {
    try {
      const res = await reportApi.getLeadReport(params);

      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetStaffSaleReport = createAsyncThunk<IResponseGetStaffSaleReport, IGetActivity>(
  GET_STAFF_SALE_REPORT,
  async (params: IGetActivity = {}, { rejectWithValue }) => {
    try {
      const res = await reportApi.getStaffSaleReport(params);

      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetProjectReport = createAsyncThunk<IResponseGetProjectReport, IGetActivity>(
  GET_PROJECT_REPORT,
  async (params: IGetActivity = {}, { rejectWithValue }) => {
    try {
      const res = await reportApi.getProjectReport(params);

      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetSaleReport = createAsyncThunk<IResponseGetProjectReport, IGetActivity>(
  GET_PROJECT_REPORT,
  async (params: IGetActivity = {}, { rejectWithValue }) => {
    try {
      const res = await reportApi.getSaleReport(params);

      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetClosingRateReport = createAsyncThunk<IResponseGetProjectReport, IGetActivity>(
  GET_CLOSING_RATE_REPORT,
  async (params: IGetActivity = {}, { rejectWithValue }) => {
    try {
      const res = await reportApi.getClosingRateReport(params);

      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetSourceReferralReport = createAsyncThunk<IResponseGetSourceReferralReport, IGetActivity>(
  GET_REFERRAL_SOURCE_REPORT,
  async (params: IGetActivity = {}, { rejectWithValue }) => {
    try {
      const res = await reportApi.getSourceReferralReport(params);

      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetTimeClockReport = createAsyncThunk<IResponseGetTimeClockReport, IGetTimeClockReport>(
  GET_TIME_CLOCK_REPORT,
  async (params: IGetTimeClockReport, { rejectWithValue }) => {
    try {
      const res = await reportApi.getTimeClockReport(params);

      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
